<table mat-table [dataSource]="stock">
  <ng-container matColumnDef="warehouse">
    <th mat-header-cell *matHeaderCellDef>Склад</th>
    <td mat-cell *matCellDef="let row">{{ row.warehouse.description }}</td>
  </ng-container>
  <ng-container matColumnDef="quan">
    <th mat-header-cell *matHeaderCellDef>Кол-во</th>
    <td mat-cell *matCellDef="let row">
      <div class="stockWrapper {{ row.quan > 0 ? 'myStock' : 'nonStock' }}">
        {{ row.quan }}
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="cell">
    <th mat-header-cell *matHeaderCellDef>Адрес</th>
    <td mat-cell *matCellDef="let row">
      <div class="cellList" *ngIf="getBalances(row).length; else legacyCell">
        <span class="cellBadge" *ngFor="let balance of getBalances(row)">
          {{ balance.code }}: {{ balance.qty }}
        </span>
      </div>
      <ng-template #legacyCell>{{ row.cell }}</ng-template>
    </td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row">
      <div class="btnHolder">
        <button mat-icon-button type="button" color="primary" (click)="edit(row)"
          matTooltip="Адресное хранение"
          [attr.aria-label]="'Адресное хранение: ' + row.warehouse.description">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
</table>
